var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 73,
    viewBox: "0 0 52 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1205 57.9183L36.7364 40.3307C39.2754 37.9319 39.2367 33.8798 36.6523 31.53L18.0364 14.6038C14.1822 11.0995 8 13.8341 8 19.0431L8 53.5569C8 58.8205 14.2943 61.533 18.1205 57.9183Z",
    fill: "#057DCD",
    stroke: "#057DCD",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1892 47.4454L30.796 39.2717C32.5742 37.0716 32.5742 33.9284 30.796 31.7283L24.1892 23.5546C20.6334 19.1554 13.5229 21.6697 13.5229 27.3263L13.5229 43.6737C13.5229 49.3302 20.6334 51.8446 24.1892 47.4454Z",
    fill: "white",
    stroke: "#54BEFF",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer);
export default __webpack_public_path__ + "static/media/pointer.88a0d251c46ea32f470f529dd4921cb9.svg";
export { ForwardRef as ReactComponent };